import { render, staticRenderFns } from "./EditContact.vue?vue&type=template&id=4a3675ed&scoped=true&"
import script from "./EditContact.vue?vue&type=script&lang=js&"
export * from "./EditContact.vue?vue&type=script&lang=js&"
import style0 from "./EditContact.vue?vue&type=style&index=0&id=4a3675ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3675ed",
  null
  
)

export default component.exports